define('InfiniteScroll.GoToTop.View', [
    'Backbone',
    'infinite_scroll_gototop.tpl',
    'jQuery'
], function InfiniteScrollFacetItemsView(
    Backbone,
    infiniteScrollGoToTopTpl,
    jQuery
) {
    'use strict';

    return Backbone.View.extend({
        events: {
            'click [data-action="scroll-to-top"]': 'scrollToTop'
        },

        template: infiniteScrollGoToTopTpl,

        scrollToTop: function scrollToTop() {
            jQuery('html, body').animate({
                scrollTop: 0
            }, 700);
            return false;
        }
    });
});
